import { Steps as AntdSteps } from "antd"

const ProgressSteps = props => {
  return <AntdSteps {...props} />
}
export default ProgressSteps
